"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.defaultOffset = exports.defaultLimit = exports.defaultOrderByOptions = exports.FAILED = exports.FETCHED = exports.FETCHING = exports.STANDBY = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/bid/participants");
exports.STANDBY = 'STANDBY';
exports.FETCHING = 'FETCHING';
exports.FETCHED = 'FETCHED';
exports.FAILED = 'FAILED';
exports.defaultOrderByOptions = {
    orderBy: 'name',
    order: 'asc'
};
exports.defaultLimit = 350;
exports.defaultOffset = 0;
const initialParticipant = {
    isOpen: false,
    status: 'STANDBY',
    errors: fp.option.none,
    fields: []
};
const initialCopy = {
    isOpen: false,
    selected: undefined,
    status: 'STANDBY'
};
exports.initialState = {
    status: exports.STANDBY,
    removeStatus: exports.STANDBY,
    toggleStatus: exports.STANDBY,
    selected: [],
    list: [],
    limit: exports.defaultLimit,
    offset: exports.defaultOffset,
    itemsPerPage: [350, 700, 1400],
    searchString: '',
    orderByOptions: Object.assign({}, exports.defaultOrderByOptions),
    filterOptions: {},
    add: Object.assign({}, initialParticipant),
    copy: Object.assign({}, initialCopy)
};
const statusLens = monocle.Lens.fromProp('status');
const removeStatusLens = monocle.Lens.fromProp('removeStatus');
const toggleStatusLens = monocle.Lens.fromProp('toggleStatus');
const selectedLens = monocle.Lens.fromProp('selected');
const listLens = monocle.Lens.fromProp('list');
const limitLens = monocle.Lens.fromProp('limit');
const offsetLens = monocle.Lens.fromProp('offset');
const searchStringLens = monocle.Lens.fromProp('searchString');
const orderByOptionsLens = monocle.Lens.fromProp('orderByOptions');
const filterOptionsLens = monocle.Lens.fromProp('filterOptions');
const addLens = monocle.Lens.fromProp('add');
const addIsOpenLens = monocle.Lens.fromProp('isOpen');
const addErrorsLens = monocle.Lens.fromProp('errors');
const addStatusLens = monocle.Lens.fromProp('status');
const addFieldsLens = monocle.Lens.fromProp('fields');
const copyLens = monocle.Lens.fromProp('copy');
const copyIsOpenLens = monocle.Lens.fromProp('isOpen');
const copySelectLens = monocle.Lens.fromProp('selected');
const copyStatusLens = monocle.Lens.fromProp('status');
exports.methods = {};
exports.methods[ActionTypes.FETCH_REQUEST] = (state, action) => statusLens.set(exports.FETCHING)(state);
exports.methods[ActionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(listLens.set(action.payload), statusLens.set(exports.FETCHED))(state);
exports.methods[ActionTypes.FETCH_FAILED] = (state, action) => statusLens.set(exports.FAILED)(state);
// Remove
exports.methods[ActionTypes.REMOVE_REQUEST] = (state, action) => removeStatusLens.set('REMOVING')(state);
exports.methods[ActionTypes.REMOVE_SUCCESS] = (state, action) => fp.function.compose(selectedLens.set([]), removeStatusLens.set('REMOVED'))(state);
exports.methods[ActionTypes.REMOVE_FAILED] = (state, action) => removeStatusLens.set(exports.FAILED)(state);
// Toggle
exports.methods[ActionTypes.TOGGLE_SELECT] = (state, action) => selectedLens.modify((x) => {
    if (action.payload.select) {
        return [...x, action.payload.participant];
    }
    return x.filter((y) => y.user.id !== action.payload.participant.user.id);
})(state);
// Init
exports.methods[ActionTypes.SET_INIT_DATA] = (state, action) => {
    const _a = action.payload, { search, order, orderBy, limit, offset } = _a, filters = __rest(_a, ["search", "order", "orderBy", "limit", "offset"]);
    return fp.function.compose(searchStringLens.set(search || ''), orderByOptionsLens.modify((x) => {
        const clone = Object.assign({}, x);
        if (orderBy) {
            clone.orderBy = orderBy;
        }
        if (order === 'asc' || order === 'desc') {
            clone.order = order;
        }
        return clone;
    }), limitLens.modify((x) => {
        const l = parseInt(limit || '', 10);
        if (isNaN(l)) {
            return x;
        }
        return l;
    }), offsetLens.modify((x) => {
        const o = parseInt(offset || '', 10);
        if (isNaN(o)) {
            return x;
        }
        return o;
    }), filterOptionsLens.set(filters))(state);
};
exports.methods[ActionTypes.SET_SEARCH_STRING] = (state, action) => searchStringLens.set(action.payload)(state);
exports.methods[ActionTypes.SET_PAGINATION_OPTIONS] = (state, action) => fp.function.compose(limitLens.set(action.payload.limit), offsetLens.set(action.payload.offset))(state);
exports.methods[ActionTypes.SET_COLUMN_FILTER] = (state, action) => filterOptionsLens.modify((x) => {
    const clone = Object.assign({}, x);
    const { field, value } = action.payload;
    if (value === undefined) {
        delete clone[field];
    }
    else {
        clone[field] = value;
    }
    return clone;
})(state);
exports.methods[ActionTypes.SET_ORDER_BY] = (state, action) => orderByOptionsLens.set(action.payload)(state);
exports.methods[ActionTypes.CLEAR] = (state, action) => (Object.assign({}, exports.initialState));
// ADD PARTICIPANT
exports.methods[ActionTypes.TOGGLE_ADD_PARTICIPANT] = (state, action) => addLens.modify((x) => {
    if (x.isOpen) {
        return Object.assign({}, initialParticipant);
    }
    return addIsOpenLens.set(true)(x);
})(state);
exports.methods[ActionTypes.ADD_PARTICIPANTS_ADD_ROW] = (state, action) => addLens.compose(addFieldsLens).modify((x) => [...x, action.payload])(state);
exports.methods[ActionTypes.ADD_PARTICIPANTS_REMOVE_ROW] = (state, action) => addLens
    .compose(addFieldsLens)
    .modify((rows) => rows.filter((r) => r.uuid !== action.payload))(state);
exports.methods[ActionTypes.ADD_PARTICIPANTS_UPDATE_ROW] = (state, action) => addLens.compose(addFieldsLens).modify((rows) => rows.map((row) => {
    if (row.uuid === action.payload.uuid) {
        return Object.assign(Object.assign({}, row), { emails: action.payload.emails });
    }
    return row;
}))(state);
exports.methods[ActionTypes.ADD_PARTICIPANTS_LANGUAGE_ROW] = (state, action) => addLens.compose(addFieldsLens).modify((rows) => rows.map((row) => {
    if (row.uuid === action.payload.uuid) {
        return Object.assign(Object.assign({}, row), { language: action.payload.language });
    }
    return row;
}))(state);
exports.methods[ActionTypes.ADD_PARTICIPANTS_REQUEST] = (state, action) => fp.function.compose(addLens.compose(addErrorsLens).set(fp.option.none), addLens.compose(addStatusLens).set('INVITING'))(state);
exports.methods[ActionTypes.ADD_PARTICIPANTS_SUCCESS] = (state, action) => addLens.compose(addStatusLens).set('INVITED')(state);
exports.methods[ActionTypes.ADD_PARTICIPANTS_VALIDATION] = (state, action) => fp.function.compose(addLens.compose(addErrorsLens).set(fp.option.some(action.payload)), addLens.compose(addStatusLens).set('STANDBY'))(state);
exports.methods[ActionTypes.ADD_PARTICIPANTS_FAILED] = (state, action) => addLens.compose(addStatusLens).set('FAILED')(state);
exports.methods[ActionTypes.TOGGLE_USER_FROM_GROUP] = (state) => toggleStatusLens.set('SAVING')(state);
exports.methods[ActionTypes.TOGGLE_USER_FROM_GROUP_SUCCESS] = (state) => toggleStatusLens.set('SUCCESS')(state);
exports.methods[ActionTypes.TOGGLE_USER_FROM_GROUP_FAILURE] = (state) => toggleStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.TOGGLE_COPY_PARTICIPANT] = (state, action) => {
    const isOpen = copyLens.get(state).isOpen;
    if (isOpen) {
        return copyLens.set(Object.assign({}, initialCopy))(state);
    }
    return copyLens.compose(copyIsOpenLens).modify((s) => {
        if (action.payload !== undefined) {
            return action.payload;
        }
        return !s;
    })(state);
};
exports.methods[ActionTypes.SELECT_BID] = (state, action) => copyLens.compose(copySelectLens).set(action.payload.bid)(state);
exports.methods[ActionTypes.COPY_PARTICIPANT] = (state, action) => copyLens.compose(copyStatusLens).set('COPYING')(state);
exports.methods[ActionTypes.COPY_PARTICIPANT_FAILURE] = (state, action) => copyLens.compose(copyStatusLens).set('FAILED')(state);
exports.methods[ActionTypes.COPY_PARTICIPANT_SUCCESS] = (state, action) => copyLens.compose(copyStatusLens).set('SUCCESS')(state);
//# sourceMappingURL=participants.js.map